import dClient from "../../Components/api/reduxLoaderApi";
import failStatus from "../../Components/utils/failStatus";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";
import {initSliderForm} from "./slice";


export const getSliderById = (id, callback= false) => async (
    dispatch,
    getState
) => {
    const res = await dClient(
        'get',
        `slider/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(initSliderForm(res.data.slider))
    return callback && callback();
}

export const createSlider = (data, callback= false) => async (
    dispatch,
    getState
) => {
    const res = await dClient(
        'post',
        `slider`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
}

export const editSlider = (id,data, callback= false) => async (
    dispatch,
    getState
) => {
    const res = await dClient(
        'put',
        `slider/${id}`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ویرایش شد</h3>, false))
    return callback && callback();
}



export const deleteSlider = (id, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `slider/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت حذف شد</h3>, false))
    return callback && callback();
};

export const getSliderImages = (id, callback= false) => async (
    dispatch,
    getState
) => {
    const res = await dClient(
        'get',
        `slider/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    return callback && callback(res.data.slider);
}

export const deleteSlideImage = (id, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `slider-image/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت حذف شد</h3>, false))
    return callback && callback();
};

export const registerSlideImage = (data, callback= false) => async (
    dispatch,
    getState
) => {
    const res = await dClient(
        'post',
        `slider-image`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
}

export const editSlideImage = (id,data, callback= false) => async (
    dispatch,
    getState
) => {
    const res = await dClient(
        'post',
        `slider-image/${id}`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ویرایش شد</h3>, false))
    return callback && callback();
}

